/* eslint-disable react/react-in-jsx-scope */
import { Tag } from 'antd'

const REPORT_SOURCE = {
	YOUTUBE: 'youtube-extension',
	PUBLIC: 'public-api',
	PDF: 'PDF',
}

/** `no_definition` report `content` is shaped like `word,...,lang,id` (lang is second-to-last comma segment). */
export const REPORT_WORD_RATING_NO_DEFINITION = 'no_definition'

/**
 * Reads en/vi from a report word string (comma-separated; language is the second-to-last segment).
 * @param {string|null|undefined} raw
 * @returns {'en'|'vi'|null}
 */
export const parseReportWordLanguageFromString = raw => {
	if (raw == null || typeof raw !== 'string') return null
	const parts = raw
		.split(',')
		.map(s => s.trim())
		.filter(Boolean)
	if (parts.length < 2) return null
	const lang = parts[parts.length - 2].toLowerCase()
	if (lang === 'en' || lang === 'vi') return lang
	return null
}

/**
 * @param {object} record report row
 * @returns {'en'|'vi'|null}
 */
export const getReportRecordWordLanguage = record => {
	if (!record) return null
	const raw =
		record.rating === REPORT_WORD_RATING_NO_DEFINITION
			? record.content
			: record.createdBy
	return parseReportWordLanguageFromString(String(raw ?? ''))
}

/**
 * Lemma text before `,...,lang,id` (same comma rules as language parsing).
 * @param {string|null|undefined} raw
 * @returns {string}
 */
export const parseReportWordLemmaFromString = raw => {
	if (raw == null || typeof raw !== 'string') return ''
	const parts = raw
		.split(',')
		.map(s => s.trim())
		.filter(Boolean)
	if (parts.length >= 3) {
		const lang = parts[parts.length - 2].toLowerCase()
		if (lang === 'en' || lang === 'vi') {
			return parts.slice(0, -2).join(', ')
		}
	}
	return parts[0] || ''
}

/**
 * @param {object} record report row
 * @returns {string}
 */
export const getReportRecordWordLemma = record => {
	if (!record) return ''
	const raw =
		record.rating === REPORT_WORD_RATING_NO_DEFINITION
			? record.content
			: record.createdBy
	return parseReportWordLemmaFromString(String(raw ?? ''))
}

export const formatReportSource = value => {
	let color = 'cyan'
	switch (value) {
		case REPORT_SOURCE.YOUTUBE: {
			color = 'magenta'
			break
		}

		case REPORT_SOURCE.PUBLIC: {
			color = 'geekblue'
			break
		}
		case REPORT_SOURCE.PDF: {
			color = 'gold'
			break
		}
		default:
			break
	}

	return <Tag color={color}>{value}</Tag>
}
